export default "__VITE_ASSET__BdoJxvRU__"